module.exports = __webpack_public_path__ + "static/media/img_26.d80fe3db.JPG";